/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsAtSign: {
  name: 'at-sign';
  data: string;
} = {
  name: 'at-sign',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 8a6.5 6.5 0 0 1 13 0 1.5 1.5 0 0 1-3 0V5a.5.5 0 0 0-1 0v.55a3.5 3.5 0 1 0 .6 4.075A2.5 2.5 0 0 0 15.5 8a7.5 7.5 0 1 0-2.5 5.59.5.5 0 1 0-.667-.745A6.5 6.5 0 0 1 1.5 8Zm9 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
